module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_question-936554c83b557e16cffb00465df5da0b.svg";